export default "__VITE_ASSET__BGS74e9x__"